import api from "./configuration";
import apiUrl from "./url";
import store from "@/store";
const request = async (method, id, data) => {
	const token = store.getState().token;
	if (!token) throw Error("Sessione non più attiva.");
	return (
		await api.request({
			method,
			url: apiUrl + `/Players/${id}/ai-profile`,
			data,
			useAuthInterceptor: false,
			headers: {Authorization: `Bearer ${token}`},
		})
	).data;
};
export const ScoutingProfilesAPI = {
	get: (id) => request("GET", id),
	save: (id, data) => request("PUT", id, data),
};
